import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { DOMOrientation } from "../../../library-js/dom/DOMOrientation";
import { DOMScroll } from "../../../library-js/dom/DOMScroll";
import { Rokojori } from "../../js/Rokojori";

export class ImageHeader
{
  static readonly type = new ElementType( "image-header" );
  static _initialized = false;  

  static _elements:HTMLImageElement[] = [];


  static applyOnDocument()
  {
    ImageHeader.initialize();
    ImageHeader._elements = [];
    ImageHeader.type.forAllInDoc( e => this.applyOnElement( e  ) );
  }

  static applyOnElement( e:Element )
  {
    ImageHeader._elements.push( ElementType.image.query( e ) as HTMLImageElement );
  }

  static initialize()
  {
    if ( this._initialized )
    {
      return;
    }
    
    this._initialized = true;

    Rokojori.$.onAnimationFrame.addListener(
      ()=>
      {
        ImageHeader.update();
      }
    )
  }

  static update()
  {
  
    this._elements.forEach(
      ( e )=>
      {
        if ( DOMOrientation.isPortrait )
        {
          e.style.transform = "";
          return;
        }

        let scroll = DOMScroll.get();
        let offset = Math.min( 10, Math.max( scroll.y - 50, 0 ) * 0.02 );
        e.style.transform =`translateY( calc( ${offset * 1.5} * var(--sw) ) )`;
        e.style.filter =`brightness(${100-offset*3}%)`;
      }
    )
  }
}